<template>
  <v-card
    class="card-section"
    :class="[
      { 'card-section--dense': dense },
      !dense && 'ma-2',
      selected && 'card-section--selected',
    ]"
    :width="dense ? '100%' : '250px'"
    hover
    v-on:click="$emit('click', emitValue)"
  >
    <!-- Dense layout: icon/image on the left, title on the right -->
    <div v-if="dense" class="card-section__dense-content pa-3">
      <div class="card-section__dense-media d-flex align-center justify-center">
        <template v-if="icon">
          <v-icon size="36" color="grey darken-1">{{ icon }}</v-icon>
        </template>
        <template v-else>
          <v-img :src="imgUrl" contain width="60" height="60"></v-img>
        </template>
      </div>
      <div class="card-section__dense-title ml-4">
        <div class="card-section__title text-subtitle-1">
          {{ displayTitle }}
        </div>
      </div>
    </div>

    <!-- Default layout: media on top, title in footer -->
    <template v-else>
      <v-menu v-if="showActions" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon small class="card-menu-btn" v-on="on" @click.stop>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="$emit('delete', section)">
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div
        v-if="icon"
        class="card-section__icon-container d-flex align-center justify-center"
        style="height: 167px; background-color: #f5f5f5"
      >
        <v-icon size="80" color="grey darken-1">{{ icon }}</v-icon>
      </div>

      <v-img v-else class="card-section__image" height="167px" :src="imgUrl">
      </v-img>
      <v-card-actions class="card-section__footer pa-3">
        <v-card-title class="card-section__title pa-0">
          {{ displayTitle }}
        </v-card-title>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "card-section",
  props: {
    //Section model for this card
    section: {
      default: () => ({}),
      type: Object,
    },
    // Optional explicit title; falls back to section.name
    title: {
      default: "",
      type: String,
    },
    //Image to display on section card
    imgUrl: {
      default: "https://activstoredev.blob.core.windows.net/test/box.png",
      type: String,
    },
    //Icon to display instead of image (optional)
    icon: {
      default: null,
      type: String,
    },
    // Dense mode: compact horizontal layout with media on the left
    dense: {
      type: Boolean,
      default: false,
    },
    // Optional selected state for highlighting
    selected: {
      type: Boolean,
      default: false,
    },
    // Show action menu (delete, etc.)
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayTitle() {
      return this.title && this.title.length
        ? this.title
        : this.section && this.section.name
        ? this.section.name
        : "";
    },
    emitValue() {
      return this.section && this.section.name ? this.section.name : this.title;
    },
  },
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss">
@use "@/styles/CardSection.scss";
</style>
